import { aawzDate } from '@utils/dates/aawz-date'
import { parseDateSafe } from '@utils/Format'

// A data como o backend serializa (`JSONEncoderExtendedDayFirst…`): dia
// primeiro, com ou sem hora. `parseDateSafe` não serve para ela: o
// round-trip `format()` do `aawzDate` monta a DATA em UTC e a HORA local, então
// "12/09/2026 22:49" vira "13/09/2026 22:49", o formato é descartado e o
// `Date` nativo lê MM/DD — 9 de dezembro, no futuro: a conversa das 22h49
// aparecia como "agora" e no topo de Recentes (medido em 14/09/2026, com o
// print do usuário). Aqui o formato é decidido pela FORMA da string, sem
// round-trip. Dívida registrada em `design-system/guidelines.md › Design-system gaps` (`aawz-date/format.js`, UTC × local).
const FORMATO_COM_HORA = /^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}(:\d{2})?$/
const FORMATO_SO_DATA = /^\d{2}\/\d{2}\/\d{4}$/
const MASCARA_DIA_HORA = 'DD/MM/YYYY HH:mm'
const MASCARA_DIA_HORA_SEGUNDOS = 'DD/MM/YYYY HH:mm:ss'
const MASCARA_SO_DIA = 'DD/MM/YYYY'

// A máscara do `aawzDate` decidida pela FORMA da string; `null` quando não é
// uma data dia-primeiro do backend. Com segundos a string é mais longa que a
// máscara sem eles.
function mascaraDaDataDoBackend(texto) {
  if (FORMATO_COM_HORA.test(texto)) {
    return texto.length > MASCARA_DIA_HORA.length ? MASCARA_DIA_HORA_SEGUNDOS : MASCARA_DIA_HORA
  }
  if (FORMATO_SO_DATA.test(texto)) return MASCARA_SO_DIA
  return null
}

function instanteNaMascara(texto, mascara) {
  const data = aawzDate(texto, mascara)
  return data.isValid() ? data.valueOf() : null
}

/**
 * Instante (epoch ms) de uma data vinda do backend — ou de um ISO local.
 * `null` quando não há data legível.
 *
 *   instanteDaDataDoBackend('12/09/2026 22:49')  // 12 de setembro, 22h49 local
 */
export function instanteDaDataDoBackend(valor) {
  if (!valor) return null
  const texto = typeof valor === 'string' ? valor.trim() : ''
  const mascara = texto ? mascaraDaDataDoBackend(texto) : null
  if (mascara) return instanteNaMascara(texto, mascara)
  const data = parseDateSafe({ date: valor })
  return data ? data.valueOf() : null
}
